import React from 'react'
import { Link } from 'react-router-dom'
import styles from './styles.scss'

const TeacherBasePage = ({ children }) => {

  const menuItem = [
    { label: '首页', url: '/teacher/index', icon: '' },
    {
        label: '课程',
        icon: '',
        children: [
            { label: '我的课程', url: '/teacher/myclazz' },
            { label: '作业批改', url: '/teacher/homework' }
        ]
    },
    {
        label: '班级',
        icon: '',
        children: [
            { label: '班级信息', url: '/teacher/class-info' },
            { label: '我的课程', url: '/teacher/class-member' },
            { label: '学生作品', url: '/teacher/student-share' }
        ]
    }
]

  return (
    <div className={styles.basePageContent}>
      <div className={styles.topMenu}></div>
      <div className={styles.content}>
        <div className={styles.sideMenu}>
          {
            menuItem.map((item, index) => {
              if (!!item.children) {
                return <div key={index}>
                  <div className={styles.sideItem}>
                    <span>{item.label}</span>
                    <span>^</span>
                  </div>
                  {
                    item.children.map((subMenu, subIndex) => (
                      <Link key={subIndex} className={styles.subItem} to={subMenu.url}>{subMenu.label}</Link>
                    ))
                  }
                </div>
              }
              return <Link key={index} className={styles.sideItem} to={item.url}>{item.label}</Link>
            })
          }
        </div>
        <div className={styles.pageContent}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default TeacherBasePage
